import Api from './axios';
import log from './logApi';
import { createCounterTopUrl } from '../utils/createCounterTopUrl';

const saveOnlineDesign = (
  svocId,
  designGuid,
  designName,
) => {
  const path = 'countertops/api/createOnlineDesign';
  const params = { svocId, designGuid, designName };

  return Api().post(createCounterTopUrl(path), params)
    .then((response) => response.data)
    .catch((ee) => {
      log(`Error saving design: ${ee}, svocId: ${svocId}, designGuid: ${designGuid}, designName: ${designName}`,
        'Error');
      throw ee;
    });
};

export default saveOnlineDesign;
